// /auth/accept-invite — exchange a magic-link token for a JWT.

import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthShell from "../layouts/AuthShell";
import { auth, ApiError } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setError("No invite token in the URL.");
      return;
    }
    // If the magic-link URL also carries ?ref=<code>, pass it through so
    // the new tenant gets stamped with the referrer at activation time.
    const referralCode = params.get("ref") ?? undefined;
    (async () => {
      try {
        const tok = await auth.acceptInvite(token, referralCode);
        signIn(tok);
        navigate("/", { replace: true });
      } catch (e: unknown) {
        setError(e instanceof ApiError ? e.message : "Invite verification failed");
      }
    })();
  }, [params, signIn, navigate]);

  return (
    <AuthShell>
      {error ? (
        <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">
          {error}
        </p>
      ) : (
        <p className="text-sm text-gray-700">Signing you in…</p>
      )}
    </AuthShell>
  );
}
